// extracted by mini-css-extract-plugin
export default {"DesignWarningModalContent":"design-warning-modal-module_DesignWarningModalContent_D4OAq"};